import classNames from 'classnames';
import { MdMenu, MdStar } from 'react-icons/md';
import Input from '../form/FormikInput';

const LinkEdit = ({ values, index, linkIndex, onChange = () => {}, onRemove = () => {}, setFieldValue = () => {} }) => {
    const link = values?.snapshots[index].links[linkIndex];
    return (
        <div>
            <div className="row bottom-md">
                <div className="col-xs-12 col-md-4">
                    <Input
                        inputClassName="mb-md-0"
                        label="Display Name"
                        id={`snapshots[${index}].links[${linkIndex}].display_name`}
                        value={values?.snapshots[index].links[linkIndex].display_name}
                        onChange={onChange}
                    />
                </div>
                <div className="col-xs-12 col-md-4">
                    <Input
                        inputClassName="mb-md-0"
                        label="Category URL"
                        id={`snapshots[${index}].links[${linkIndex}].url`}
                        value={values?.snapshots[index].links[linkIndex].url}
                        onChange={onChange}
                    />
                </div>
                <div className="col-xs-12 col-md-4">
                    <button
                        className={classNames('button btn-sm btn-outline-primary', {
                            active: link.highlighted
                        })}
                        type="button"
                        onClick={() => {
                            setFieldValue(`snapshots[${index}].links[${linkIndex}].highlighted`, !link.highlighted);
                        }}
                    >
                        {link.highlighted && <MdStar />}
                        Highlight
                    </button>
                    <button className="button button-danger btn-sm" onClick={onRemove}>
                        Remove
                    </button>
                    <MdMenu />
                </div>
            </div>
        </div>
    );
};

export default LinkEdit;
